import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  // useApolloClient,
  useQuery
} from "react-apollo";

import { OrdersTable } from "../../../../components/Orders";
// import { UPDATE_ORDER_MUTATION } from "../../../../graphql/Orders/Orders.graphql";
import Loading from "../../../../components/Loading";
import { ALL_SYSTEM_CODES_QUERY } from "../../../../graphql/SystemCodes/SystemCodes.graphql";
// import { ourToast as toast, runPromisesInSeries } from "../../../../utils";

// class ImportedError extends Error {}

const Imported = ({ filters }) => {
  // const client = useApolloClient();
  const history = useHistory();
  // const [loading, setLoading] = useState(false);
  const [selectedFlatRows, setSelectedFlatRows] = useState([]);

  const systemCodeStatus = useQuery(ALL_SYSTEM_CODES_QUERY, {
    variables: {
      where: {
        Category_in: ["Order", "ELD"],
        CodeName_in: ["OrderStatus", "ELDStatus"],
        CodeId_in: ["IMP", "EXP", "EXD"]
      }
    }
  });
  // const handleResetToExported = async selectedData => {
  //   try {
  //     if (!selectedData.length) {
  //       throw ImportedError(
  //         "Please select some orders to be reset to exported"
  //       );
  //     }
  //     setLoading(true);
  //     const { SystemCodes } = systemCodeStatus.data;
  //     const ELDStatus = SystemCodes.find(s => s.CodeId === "EXD");
  //     const Status = SystemCodes.find(s => s.CodeId === "EXP");

  //     await runPromisesInSeries(
  //       selectedData.map((RecId, index) => {
  //         const obj = {
  //           mutation: UPDATE_ORDER_MUTATION,
  //           variables: {
  //             data: {
  //               StatusRecIdRef: Status.RecId,
  //               ELDStatusRecIdRef: ELDStatus.RecId,
  //               DateExported: new Date(),
  //               DateImported: null,
  //               PickupTimeIn: null,
  //               PickupTimeOut: null,
  //               DeliveryTimeIn: null,
  //               DeliveryTimeOut: null,
  //               ShippersNumber: null,
  //               LoadNumber: null,
  //               Scale: null,
  //               TryCock: null,
  //               TankID: null,
  //               BTU: null,
  //               HotFlag: false,
  //               PickupInches: null,
  //               PickupPressure: null,
  //               PickupTemperature: null,
  //               DeliveryInches: null,
  //               DeliveryPressure: null,
  //               DeliveryTemperature: null
  //             },
  //             where: {
  //               RecId
  //             }
  //           }
  //         };
  //         if (index === selectedData.length - 1) {
  //           obj.refetchQueries = ["ALL_ORDERS_VIEW_QUERY"];
  //         }
  //         return () => client.mutate(obj);
  //       })
  //     );

  //     setLoading(false);
  //     toast.success("Orders reseted to exported successfully");
  //   } catch (err) {
  //     if (err instanceof ImportedError) {
  //       toast.error(err.message);
  //     } else if (!selectedData.length) {
  //       toast.error("Please select some orders to be reset to exported");
  //     } else {
  //       toast.error("Error reseting Orders to Exported.");
  //     }
  //   }
  // };

  if (
    // loading ||
    systemCodeStatus?.loading
  ) {
    return <Loading />;
  }
  if (systemCodeStatus?.data?.SystemCodes.length > 0) {
    const { SystemCodes } = systemCodeStatus.data;
    const { RecId } = SystemCodes.find(s => s.CodeId === "IMP");
    return (
      <OrdersTable
        // callToAction1={handleResetToExported}
        initialSortBy={[
          { id: "PickupDate", desc: false },
          { id: "Trip", desc: false },
          {
            id: "Leg",
            desc: false
          }
        ]}
        selectedFlatRows={selectedFlatRows}
        setSelectedFlatRows={setSelectedFlatRows}
        title="Imported from ELD"
        where={{ ...filters, StatusRecIdRef: RecId }}
        onCellClick={cell => {
          if (cell.column.id !== "selection") {
            history.push(`/dispatch/orders/${cell.row.original.RecId}/BOL-ELD`);
          }
        }}
      />
    );
  }
};
export default Imported;
